import React, { useState, useEffect, useContext } from "react";
import { Table, Tooltip, Select, Button, message } from "antd";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import CallMadeIcon from "@material-ui/icons/CallMade";
import moment from "moment-timezone";
import { formatCallDate, formatCallTime } from "../../../../utils/callLogTime";
import { piopiy, piopiyDialUser } from "../../../../utils/piopiy";
import { getUUID } from "../../../../_helpers/utils";
import { callContext } from "../../../../App";
import CallHistoryModal from "./CallHistoryModal";
import NewCustomerForm from "../../CustomerDetails/NewCustomerForm";
import { platformApi } from "../../../../api";

const { Option } = Select;

const CallLogsTable = ({
  data,
  paginationFilters,
  setFilters,
  limit,
  total,
  spinner,
}) => {
  const telecmiUser = localStorage.getItem("selectedTelecmiUserId");
  const { setMobileNumber } = useContext(callContext);
  const [selectedCall, setSelectedCall] = useState(null);
  const [callHistoryModalVisible, setCallHistoryModalVisible] = useState(false);
  const [newCustomerModalVisible, setNewCustomerModalVisible] = useState(false);
  const [newCustomerPhone, setNewCustomerPhone] = useState(null);
  const [cusId, setCusId] = useState("");
  const [customerName, setCustomerName] = useState("");
const [customerType, setCustomerType] = useState("");


  // Get unique user names from data
  const uniqueUsers = [
    ...new Set(data.map((item) => item.user_name || "Unknown")),
  ];

  const handleAttendedByChange = (value) => {
    const updatedFilters = { ...paginationFilters, attendedBy: value };
    setFilters(updatedFilters);
  };

  const handleRowClick = (record) => {
    setSelectedCall(record);
    setCallHistoryModalVisible(true);
  };

  const setCustomerId = () => {
    platformApi.post("/api/idGenerate/customer").then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        setCusId(response.data);
      } else {
        message.error("Couldn't fetch id");
      }
    });
  };

  const addCustomerData = (customer) => {
    if (customer.id) {
      // Handle update if needed
      message.success("Customer updated successfully!");
    } else {
      // Handle new customer addition
      message.success("Customer added successfully!");
      
      // You can add additional logic here if needed, like refreshing the call logs
    }
  };

  // Filter data based on attendedBy filter
  const filteredData = React.useMemo(() => {
    if (!paginationFilters.attendedBy) {
      return data;
    }
    return data.filter((item) => {
      const userName = item.user_name || "Unknown";
      return userName === paginationFilters.attendedBy;
    });
  }, [data, paginationFilters.attendedBy]);

  const viewModuleDetails = (record) => {
    console.log("record:", record);

    if (
      !record.moduleid &&
      record.module !== "Call-Back" &&
      record.module !== "new_customer"
    ) {
      message.info("No module details available for this record");
      return;
    }
    const phone =
      record.direction == "outbound"
        ? record.to.slice(2)
        : record.from.slice(2);
    switch (record.module) {
      case "new_customer":
        setCustomerId();
        setNewCustomerPhone(phone);
        setNewCustomerModalVisible(true);
        break;
      case "jobOrder":
      case "Job-Order":
        localStorage.setItem(
          "jobOrderState",
          JSON.stringify({ jobId: record.moduleid })
        );
        window.open("/autoadmin/job_order", "_blank");
        break;
      case "Booking":
        localStorage.setItem(
          "bookingState",
          JSON.stringify({ addFlag: true, id: record.moduleid })
        );
        window.open("/autoadmin/booking_register", "_blank");
        break;
      case "Customer":
        // localStorage.setItem(
        //   "customerState",
        //   JSON.stringify({ phone: phone, editable: true })
        // );
        // window.open("/autoadmin/customer_details", "_blank");
        // break;
        setCusId(record.moduleid); // existing customer ID
  setNewCustomerPhone(phone); // prefill phone
  setCustomerName(record.customer_name || ""); // prefill name
  setCustomerType(record.customerType || "Sales Customer"); // optional
  setNewCustomerModalVisible(true);
  break;
      case "Quotation":
      case "Follow-Ups":
        window.open(
          `/autoadmin/follow-ups/${phone}/fupdate/${record.moduleid}`,
          "_blank"
        );
        break;
      case "Call-Back":
        message.info(
          `Call Back for missed call from ${record.user_name} to ${record.customer_name}`
        );
        break;
      case "Insurance":
        var route = `/autoadmin/insurance_renewal_reminder/${record.moduleid}`;
        window.open(route, "_blank");
        break;
      case "Other insurance":
        window.open(
          `/autoadmin/other_insurance_renewal_reminder/${record.moduleid}`,
          "_blank"
        );
        break;
      case "Service":
        window.open(
          `/autoadmin/service-followups/${phone}/fupdate/${record.moduleid}`,
          "_blank"
        );
        break;
      default:
        message.info("No module details available for this record");
        break;
    }
  };
  

  const columns = [
    {
      title: "Date",
      key: "date",
      render: (_, record) => formatCallDate(record),
    },
    {
      title: "Time",
      key: "time",
      render: (_, record) => formatCallTime(record),
    },
    {
      title: "Customer Number",
      key: "number",
      render: (_, record) => {
        const isInbound = record.direction === "inbound";
        const phoneNumber = isInbound ? record.from : record.to;
        const isMissed = record.status === "missed";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {isInbound ? (
              <Tooltip title="Incoming Call">
                <CallReceivedIcon
                  style={{ color: isMissed ? "red" : "green", fontSize: 16 }}
                />
              </Tooltip>
            ) : (
              <Tooltip title="Outgoing Call">
                <CallMadeIcon
                  style={{ color: isMissed ? "red" : "blue", fontSize: 16 }}
                />
              </Tooltip>
            )}
            <span>{phoneNumber || "-"}</span>
          </div>
        );
      },
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
      render: (text) => text || "Unknown Number",
    },
    {
      title: "Employee Name",
      dataIndex: "user_name",
      key: "user_name",
      render: (text) => text || "Unknown",
    },
    // {
    //   title: 'Duration (s)',
    //   dataIndex: 'duration',
    //   key: 'duration',
    //   align: 'center',
    // },
    {
      title: "Hangup Reason",
      dataIndex: "hangup_reason",
      key: "hangup_reason",
      render: (reason) => {
        const reasonMap = {
          sent_bye: "Call ended by customer",
          recv_bye: "Call ended by employee",
          recv_cancel: "Call unanswered",
          sent_reject: "Call rejected by customer",
          normal: "Call ended normally",
        };

        return reasonMap[reason] || "No reason provided";
      },
    },
    {
      title: "Module",
      key: "module",
      render: (record) => {
        const isValidModule = record.module !== "null" && record.module;

        return (
          <Button
            type="default"
            size="small"
            className={isValidModule ? "linkylink" : ""}
            style={{
              width: "105px",
              cursor: isValidModule ? "pointer" : "not-allowed",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            disabled={!isValidModule}
            onClick={(e) => {
              e.stopPropagation();
              if (isValidModule) viewModuleDetails(record);
            }}
          >
            {isValidModule ? record.module : "-"}
          </Button>
        );
      },
    },
    {
      title: "Recording",
      dataIndex: "bucketURL",
      key: "recording",
      width: 210,
      align: "center",
      render: (url, record) => {
        const isMissed = record.status === "missed";

        return isMissed || !url ? (
          "-"
        ) : (
          <audio
            controls
            style={{
              width: "170px",
              height: "40px",
              transform: "scale(0.8)",
            }}
          >
            <source src={url} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      align: "center",
      render: (text, record) => {
        const phoneNumber =
          record.direction === "inbound" ? record.from : record.to;

        return (
          <Button
            type="primary"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              if (!telecmiUser) {
                message.error("Can't place call, Login to telecmi account to continue");
                return;
              }
            
              const UniqueId = getUUID();
              setMobileNumber(phoneNumber);
              piopiyDialUser(
                piopiy,
                phoneNumber,
                UniqueId,
                "Call-Back",
                phoneNumber
              );
            
              // if (record.module === "new_customer" || record.module === "Customer") {
              //   setCustomerId(record.moduleid || getUUID());
              //   setNewCustomerPhone(phoneNumber.slice(2)); 
              //   setNewCustomerModalVisible(true);
              // }
              if (record.module === "new_customer" || record.module === "Customer") {
                setCusId(record.moduleid || ""); // use existing ID if available
                setNewCustomerPhone(phone.slice(2));
                setCustomerName(record.customer_name || "");
                setCustomerType(record.customerType || "Sales Customer");
                setNewCustomerModalVisible(true);
              }
              
            }}
          >
            Call Back
          </Button>
        );
      },
    },
  ].filter(Boolean);

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Select
          style={{ width: 200 }}
          placeholder="Filter by Attended By"
          onChange={handleAttendedByChange}
          value={paginationFilters.attendedBy}
          allowClear
        >
          <Option value="">All</Option>
          {uniqueUsers.map((user) => (
            <Option key={user} value={user}>
              {user}
            </Option>
          ))}
        </Select>
      </div>
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
        pagination={{
          current: paginationFilters.page,
          pageSize: limit,
          total: filteredData.length,
          showQuickJumper: true,
          onChange: (page) => {
            const updatedFilters = { ...paginationFilters, page };
            setFilters(updatedFilters);
          },
        }}
        loading={spinner}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
          style: { cursor: "pointer" },
        })}
      />
      <CallHistoryModal
        visible={callHistoryModalVisible}
        onClose={() => setCallHistoryModalVisible(false)}
        selectedCall={selectedCall}
        currentDirection={paginationFilters.direction}
        currentStatus={paginationFilters.status}
      />
      <NewCustomerForm
        open={newCustomerModalVisible}
        phone={newCustomerPhone}
        cusId={cusId}
        setCusId={setCusId}
        customerName={customerName} 
        customerType={customerType}  
        emitData={(data) => addCustomerData(data)}
        close={() => {
          setNewCustomerModalVisible(false);
          setNewCustomerPhone(null);
          setCustomerName("");
          setCustomerType("");
        }}
      />
    </div>
  );
};

export default CallLogsTable;
